module.exports = __webpack_public_path__ + "img/intelligent-security-solutionsimg-5.67fade92.png";